import { ConnectBatteryRoutes } from "./ConnectBattery";

export type DevicesRouteProps = {};

export const DevicesRoute: React.FC<DevicesRouteProps> = ({}) => {
  return <ConnectBatteryRoutes />;
};
